/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import {
  SHOW_MODAL,
  HIDE_MODAL,
  SHOW_MIGRATION_MODAL,
  HIDE_MIGRATION_MODAL,
  SHOW_MIGRATION_MODAL_SUCCESS,
  SHOW_MIGRATION_MODAL_ERROR,
  HIDE_MIGRATION_MODAL_ERROR,
  HIDE_MIGRATION_MODAL_SUCCESS
} from '../actions/actionTypes';

const modalState = {
  type: null,
  props: {},
  isOpen: false,
  isMigrationModalOpen: false,
  isMigrationModalSuccessOpen: false,
  isMigrationModalErrorOpen: false
};

const modalReducer = (state = modalState, action) => {
  switch (action.type) {
    case SHOW_MODAL:
      return Object.assign({}, state, { isOpen: true, type: action.payload.type, props: action.payload.props });
    case SHOW_MIGRATION_MODAL:
      return Object.assign({}, state, { isMigrationModalOpen: true });
    case HIDE_MIGRATION_MODAL:
      return Object.assign({}, state, { isMigrationModalOpen: false });
    case SHOW_MIGRATION_MODAL_SUCCESS:
      return Object.assign({}, state, { isMigrationModalSuccessOpen: true });
    case HIDE_MIGRATION_MODAL_SUCCESS:
      return Object.assign({}, state, { isMigrationModalSuccessOpen: false });
    case SHOW_MIGRATION_MODAL_ERROR:
      return Object.assign({}, state, { isMigrationModalErrorOpen: true });
    case HIDE_MIGRATION_MODAL_ERROR:
      return Object.assign({}, state, { isMigrationModalErrorOpen: false });
    case HIDE_MODAL:
      return modalState;

    default:
      return state;
  }
};

export default modalReducer;
